import { DateTime } from 'luxon';
import { action, computed, makeObservable, observable } from 'mobx';
import { ChangeEvent } from 'react';

import { WindowState } from '../../components/overlays';
import { Message, StoreNode } from '../../store';
import { Store } from '../../store/store';

export class ZoomDateSelectorWindowState
  extends StoreNode {

  readonly nodeType = 'ZoomDateSelectorWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      prevStartDate: observable,
      prevEndDate: observable,
      startDate: observable,
      endDate: observable,
      windowListener: action,
      maxEndDate: computed,
      isButtonDisabled: computed,
      handleEndDateChanged: action,
      handleStartDateChanged: action,
      submit: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;

  readonly todayDate: string = DateTime.local().toISODate();
  prevStartDate: string | undefined;
  prevEndDate: string | undefined;
  startDate: string | undefined;
  endDate: string | undefined;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  get maxEndDate(): string {
    if (!this.startDate) return '';

    return DateTime.fromISO(this.startDate).plus({ month: 1 }).toISODate() ?? '';
  }

  get isButtonDisabled(): boolean {
    return !this.startDate
      || !this.endDate
      || (this.startDate === this.prevStartDate && this.endDate === this.prevEndDate);
  }
  handleEndDateChanged(evt: ChangeEvent<HTMLInputElement>) {
    this.endDate = evt.target.value;
  }
  handleStartDateChanged(evt: ChangeEvent<HTMLInputElement>) {
    this.startDate = evt.target.value;
    this.endDate = '';
  }

  submit() {
    if (!this.startDate || !this.endDate) return;

    this.store.userDashboardPage.zoomIntegrationTabState.catalogSource.startDate = this.startDate;
    this.store.userDashboardPage.zoomIntegrationTabState.catalogSource.endDate = this.endDate;
    this.store.userDashboardPage.zoomIntegrationTabState.catalogSource.fetch();
    this.close();
  }

  close() {
    this.prevStartDate = undefined;
    this.prevEndDate = undefined;
    this.startDate = undefined;
    this.endDate = undefined;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}
